// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M3o1xXwno2c3hR2UcJE8{grid-template-columns:60px 1fr 32px;align-items:flex-end;gap:12px;display:grid}.M3o1xXwno2c3hR2UcJE8 .kdTLW9ehQ8coGr2AlzNW{margin-bottom:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `M3o1xXwno2c3hR2UcJE8`,
	"delete": `kdTLW9ehQ8coGr2AlzNW`
};
export default ___CSS_LOADER_EXPORT___;
